
// @ts-nocheck
import locale_en_46json_944c34c4 from "#nuxt-i18n/944c34c4";
import locale_zh_46json_f6e853e7 from "#nuxt-i18n/f6e853e7";

export const localeCodes =  [
  "en",
  "zh"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_944c34c4",
      load: () => Promise.resolve(locale_en_46json_944c34c4),
      cache: true
    }
  ],
  zh: [
    {
      key: "locale_zh_46json_f6e853e7",
      load: () => Promise.resolve(locale_zh_46json_f6e853e7),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: false,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      language: "en-US",
      files: [
        {
          path: "/app/ib-rewards/i18n/locales/en.json",
          cache: undefined
        }
      ]
    },
    {
      code: "zh",
      language: "zh",
      files: [
        {
          path: "/app/ib-rewards/i18n/locales/zh.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: false,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "/ib-rewards/",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    language: "en-US",
    files: [
      {
        path: "/app/ib-rewards/i18n/locales/en.json",
        cache: undefined
      }
    ]
  },
  {
    code: "zh",
    language: "zh",
    files: [
      {
        path: "/app/ib-rewards/i18n/locales/zh.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = true
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/